<sk-modal-content [title]="'label.ShareLink' | translate | uppercase"
                  (cancel)="closeWithoutResult()"
                  (closed)="closeWithoutResult()"
                  [cancelBtnText]="'label.Cancel'">
  <ng-container id="sk-modal-body">
    <p class="mb-4 sk-alert sk-alert-warning access-only-for-iris-users">
      <i class="fas fa-info-circle text-warning"></i>
      <span class="text">
        {{ 'label.AccessibleOnlyForIrisUsers' | translate }}
      </span>
    </p>

    <iris-copy-field [value]="internalLink()" (copied)="onCopyLink()"></iris-copy-field>
  </ng-container>
</sk-modal-content>
